// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InspectObject, .InspectObject > code {\n  display: block;\n}\n.InspectObject code {\n  overflow: auto;\n}", "",{"version":3,"sources":["webpack://./components/InspectObject/index.sass"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AACE;EACE,cAAA;AACJ","sourcesContent":[".InspectObject\n  &, > code\n    display: block\n  code\n    overflow: auto\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
